import { ReportProblemOutlined } from "@mui/icons-material";
import { Button } from "@mui/material";

export default function VerifyPriceAnomalyButton({ active, loading, onClick }) {
  const label = loading ? "Scanning…" : active ? "Show all" : "Find anomalies";

  return (
    <Button
      variant="outlined"
      color="secondary"
      size="small"
      startIcon={<ReportProblemOutlined />}
      disabled={loading}
      aria-pressed={active}
      aria-label={label}
      onClick={onClick}
    >
      {label}
    </Button>
  );
}
